import { render, staticRenderFns } from "./News.vue?vue&type=template&id=641e511c&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641e511c",
  null
  
)

export default component.exports